import React, { FC } from 'react';
import { Wrapper, RemoveButton, getColor } from './tag.style';
import { TagProps, TagStyles } from './tag.types';
import { withTheme } from 'styled-components';

const Tag: FC<TagProps> = ({
  label = '',
  color = TagStyles.DEFAULT,
  theme = {},
  hasRemoveButton,
  children,
  handlers,
  ariaLabel,
  className,
  highlightColor = false,
  dataAttr
}: TagProps) => {

  const content = label || children;
  let removeBtn = null;

  if ( hasRemoveButton ) {
    removeBtn = <RemoveButton 
      iconSize={8}
      iconColor={ getColor(theme, color, highlightColor).color }
      hasHover={ false }
      iconName={ 'close' }
      ariaLabel={ ariaLabel || content }
      handlers={ handlers }
      styleName={ color }
  />
  }
  
  return (
      <Wrapper 
        className={className}
        color={color}
        hasRemoveButton={hasRemoveButton}
        highlightColor={highlightColor}
        {...dataAttr}
      >
      { content }
      { removeBtn }
      </Wrapper>
  );
};

export default withTheme(Tag);
